<template>
  <div class="weights-chart-root" :class="{ isExpanded }">
    <expand-icon
      v-if="!isExpanded"
      @click="handleExpandChart"
      class="chart-expand-icon"
    />
    <v-chart class="weights-chart" :options="chartOptions" autoresize />
  </div>
</template>

<script>
import { LegendComponent, TooltipComponent } from "echarts/components";
import { RESERVE_TICKER, WEIGHT_CHART_COLORS } from "../../utils/constants";
import { mapGetters, mapMutations } from "vuex";
import ECharts from "vue-echarts";
import ExpandIcon from "vue-material-design-icons/ArrowExpand.vue";
import { PieChart } from "echarts/charts";
import { use } from "echarts/core";
use([PieChart, TooltipComponent, LegendComponent]);
export default {
  name: "weights-chart",
  props: {
    portfolio: Array,
    isExpanded: Boolean,
  },
  components: {
    "v-chart": ECharts,
    ExpandIcon,
  },
  data() {
    return {
      chartOptions: {
        tooltip: {
          trigger: "item",
          formatter: (params) => {
            if (Number(params.data.label) === Number(params.value)) {
              return `<b>${
                params.name !== RESERVE_TICKER
                  ? params.name
                  : this.$i18n.t("portfolioManager.cashReserve")
              }</b> : ${params.value}%`;
            }
            return `<b>${
              params.name !== RESERVE_TICKER
                ? params.name
                : this.$i18n.t("portfolioManager.cashReserve")
            }</b> : ${params.data.label} (${params.value}%)`;
          },
        },
        legend: {
          type: "scroll",
          orient: "vertical",
          right: 10,
          bottom: 21,
          top: 0,
          icon: "circle",
          formatter: (name) =>
            name !== RESERVE_TICKER
              ? name
              : this.$i18n.t("portfolioManager.cashReserve"),
        },
        series: [],
      },
    };
  },
  methods: {
    ...mapMutations("portfolioManagerStore", ["setExpandedChart"]),
    populateData() {
      this.chartOptions.series = [
        {
          type: "pie",
          radius:
            this.isExpanded && window.innerWidth < 1000
              ? "50%"
              : this.isExpanded
              ? "90%"
              : "60%",
          center: [this.lPosition, "50%"],
          label: {
            show: false,
          },
          data: this.portfolio.map((item) => {
            const val = this.isWholeStocks
              ? item.amount
              : item.capital
              ? item.capital
              : item.weight;
            return {
              value: (item.weight * 100).toFixed(2),
              name: item.ticker,
              label:
                this.useFractions && this.isWholeStocks
                  ? val.toFixed(4)
                  : this.isWholeStocks && !this.useFractions
                  ? Math.floor(val)
                  : this.cash
                  ? "$" + val.toFixed(2)
                  : (val * 100).toFixed(2),
            };
          }),
          color: WEIGHT_CHART_COLORS,
        },
      ];
    },
    handleExpandChart() {
      this.setExpandedChart({
        type: "weights",
        data: this.portfolio,
      });
      this.$bvModal.show("expanded-chart");
    },
  },
  mounted() {
    this.populateData();
  },
  computed: {
    ...mapGetters("portfolioManagerStore", [
      "isWholeStocks",
      "useFractions",
      "cash",
    ]),
    lPosition() {
      return window.innerWidth < 1400 ? "35%" : "50%";
    },
  },
  watch: {
    portfolio() {
      this.populateData();
    },
    useFractions() {
      this.populateData();
    },
    isWholeStocks() {
      this.populateData();
    },
  },
};
</script>

<style lang="scss" scoped>
.weights-chart-root {
  position: relative;
  &.isExpanded {
    .weights-chart {
      max-height: 70vh;
      height: 70vh;
      width: 100%;
      max-width: 100%;
    }
  }
  &:hover {
    .chart-expand-icon {
      display: block;
      opacity: 0.75;
    }
  }
  .weights-chart {
    max-height: 320px;
    max-width: 100%;
  }
}
</style>